// Sentry must be the first import — it needs to intercept module-init errors.
import './sentry';

// PHASE 1 — Bearer token fetch patch.
// Must be installed BEFORE the CSRF interceptor so that the CSRF interceptor's
// internal `originalFetch` reference is already Bearer-patched. This means even
// the CSRF Layer-2 retry (which calls originalFetch directly) carries the JWT.
// The token getter is registered lazily by supabaseClient.ts; the patch is safe
// to install now with a null getter — it becomes live before any query fires.
import { installBearerFetchPatch } from './lib/bearerFetchPatch';
installBearerFetchPatch();

// P2 CSRF: Install the global fetch interceptor before any API calls are made.
// This patches window.fetch to automatically include X-CSRF-Token on all
// mutating /api/* requests, reading the token from the wr_csrf cookie.
// NOTE: installBearerFetchPatch() above runs first so CSRF's originalFetch
// is already Bearer-patched (correct stacking order).
import { installCsrfInterceptor } from './lib/csrfInterceptor';
installCsrfInterceptor();

import { createRoot } from 'react-dom/client';

import App from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { bootRoamerPlatform } from './services/core/bootstrap';
// Register Cloudflare R2 as the primary VaultStorage provider (Sprint 091)
import './services/vault/R2VaultStorageProvider';

import './index.css';
import './styles/responsive.css';

// Boot Roamer Core™ + engines + the ten platform modules before first render.
// Best-effort by contract: a boot failure logs loudly but never blocks the UI.
try {
  bootRoamerPlatform();
} catch (err) {
  console.error('[roamer-boot] unexpected boot failure — continuing without core', err);
}

// AppErrorBoundary wraps the entire tree so any uncaught render error shows a
// branded recovery screen instead of a blank dark page (Hotfix 001, Bug #2).
createRoot(document.getElementById('root')!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);
